import get from 'lodash/get'
export default {
  async fetch() {
    await this.getEngravingPrice()
  },
  mounted() {
    this.getEngravingPrice()
  },
  data() {
    return {
      engravingPriceData: 9.99,
      engravingCompareAtPriceData: null
    }
  },
  computed: {
    engravingPrice() {
      const engravingPrice = this.engravingPriceData
      const freeBundleEngraving = this.freeBundleEngraving
      return (freeBundleEngraving) ? '0.00' : engravingPrice
    },
    engravingCompareAtPrice() {
      const engravingPrice = this.engravingPriceData
      const engravingCompareAtPrice = this.engravingCompareAtPriceData
      const freeBundleEngraving = this.freeBundleEngraving
      return (freeBundleEngraving) ? engravingPrice : engravingCompareAtPrice
    },
    freeBundleEngraving() {
      const product = this.product
      return !!(
        product &&
        product.type &&
        product.tags &&
        product.tags.includes &&
        product.type.toLowerCase() === 'bundle' &&
        product.tags.includes('free-bundle-engraving')
      )
    }
  },
  methods: {
    async getEngravingPrice() {
      const handle = 'engraving-fee'
      try {
        const engravingFee = await this.$api.getProduct({ handle })
        const variantPrice = get(
          engravingFee,
          'variants[0].price'
        )
        const variantCompareAtPrice = get(
          engravingFee,
          'variants[0].compareAtPrice'
        )
        if (variantPrice) {
          this.engravingPriceData = variantPrice
        }
        if (variantCompareAtPrice) {
          this.engravingCompareAtPriceData = variantCompareAtPrice
        }
      } catch (err) {
        console.error(err)
      }
    }
  },

}
